import ProjectsService from '@/services/api/projects.services'
import ApiClient from '@/libs/http-client'
const state = {
    projects: [],
    userProjects: [],
    boards: [],
    clients: [],
    projectUsersForMentions: [],
}

const mutations = {
    ADD_PROJECT_USERS_FOR_MENTIONS(state, payload) {
      state.projectUsersForMentions = payload
    },

    ADD_PROJECT(state, form) {
        state.projects.push(form)
    },
    SET_ALL_PROJECTS(state, payload) {
        state.projects = payload;
    },

    SET_ALL_CLIENTS(state, payload) {
        state.clients = payload;
    },

    SET_ALL_PROJECT_BOARDS(state, payload) {
      state.boards = payload;
    },
    DELETE_PROJECT(state, id) {
        let idx = state.projects.findIndex(item => item.id === id)
        state.projects.splice(idx, 1);
    },
    ARCHIVE_PROJECT(state, id) {
        let idx = state.projects.findIndex(item => item.id === id)
        state.projects[idx].active = !state.projects[idx].active
    },

    //mutations with data from back
    SET_USER_PROJECTS(state, payload) {
        state.userProjects = payload
    },
}

const actions = {
    addProject({ commit }, form) {
        commit('ADD_PROJECT', form)
    },
    deleteProject({ commit }, id) {
        commit('DELETE_PROJECT', id)
    },
    archiveProject({ commit }, id) {
        commit('ARCHIVE_PROJECT', id)
    },
    getKanbanBoards({ commit }, projectId) {
        return new Promise((resolve, reject) => {
            const request = projectId
                ? ProjectsService.getProjectStatuses(projectId)
                : ProjectsService.getTaskStatuses()
            request
                .then((response) => {
                    const payload = response?.data?.data || response?.data?.data?.data || response?.data?.data || response?.data
                    const list = Array.isArray(payload?.data) ? payload.data : payload
                    commit('SET_ALL_PROJECT_BOARDS', Array.isArray(list) ? list : [])
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    getProjectStatusesFull({ commit }, projectId) {
        return ProjectsService.getProjectStatuses(projectId, true)
    },
    addBoard(context, { projectId, id }) {
        return ProjectsService.addProjectStatus(projectId, id != null ? { id } : {})
    },
    deleteBoard(context, { projectId, statusId }) {
        return ProjectsService.deleteProjectStatus(projectId, { id: statusId })
    },
    toggleBoard(context, { projectId, statusId }) {
        return ProjectsService.toggleProjectStatus(projectId, statusId)
    },
    getAllProjects({ commit }) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('projects')
                .then((response) => {
                    commit('SET_ALL_PROJECTS', response.data.data)
                    return resolve(response)

                })
                .catch((error) => reject(error))
        })
    },


    getSingleProject(_, id) {
      return ApiClient.get(`api/projects/${id}`)
    },


    getActiveProjects({ commit }) {
      return new Promise((resolve, reject) => {
        ProjectsService.get('activeProjects')
            .then((response) => {
                commit('SET_ALL_PROJECTS', response.data.data)
                return resolve(response)

            })
            .catch((error) => reject(error))
    })
    },
    

    getAllClients({ commit }) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('allClients')
                .then((response) => {
                    commit('SET_ALL_CLIENTS', response.data.data)
                    return resolve(response)

                })
                .catch((error) => reject(error))
        })
    },

    getUserProjects({ commit }, payload) {
        return new Promise((resolve, reject) => {
            ProjectsService.get('userProjects', payload)
                .then((response) => {
                    commit('SET_USER_PROJECTS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
}

const getters = {
    getUserProjects: state => state.userProjects,
    getData: state => state.projects,
    getProjectUsersForMention: state => state.projectUsersForMentions,
    getAllBoards: state => state.boards,
    getAllClients: state => state.clients,
    getActiveProjects: state => state.projects.filter(item => item.active),
    getNonActiveProjects: state => state.projects.filter(item => !item.active),
    getProjectsByUserName: state => nickname => state.projects.filter(item => item.workers.some(worker => worker.nickname === nickname))
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
